module.exports = __webpack_public_path__ + "img/bootleg-brothers-island-hopper.717d88ed.png";